import { render, staticRenderFns } from "./costServingResume.vue?vue&type=template&id=5df83ee4&"
import script from "./costServingResume.vue?vue&type=script&lang=js&"
export * from "./costServingResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports